/**
 * Parallel resistance: 1/R = 1/R1 + 1/R2 + ...
 * Accepts suffixes: 1k, 2.2k, 470R, etc.
 */

import React, { useState, useMemo } from 'react';
import { parseEngineering, inputClass, resultClass, labelClass, hintClass } from './parseEngineering';

const ts = () => new Date().toISOString();

const ParallelResistance = () => {
  const [r1, setR1] = useState('');
  const [r2, setR2] = useState('');
  const [r3, setR3] = useState('');

  console.log(`[${ts()}] [ParallelResistance] render`);

  const r1Num = useMemo(() => {
    const v = parseEngineering(r1);
    return v != null && v > 0 ? v : null;
  }, [r1]);
  const r2Num = useMemo(() => {
    const v = parseEngineering(r2);
    return v != null && v > 0 ? v : null;
  }, [r2]);
  const r3Num = useMemo(() => {
    const v = parseEngineering(r3);
    return v != null && v > 0 ? v : null;
  }, [r3]);

  const total = useMemo(() => {
    const values = [r1Num, r2Num, r3Num].filter((x) => x != null);
    if (values.length < 2) return null;
    const inv = values.reduce((acc, r) => acc + 1 / r, 0);
    return 1 / inv;
  }, [r1Num, r2Num, r3Num]);

  return (
    <div className="space-y-4">
      <p className={hintClass}>
        1/R = 1/R1 + 1/R2 + … Use suffixes: 1k, 2.2k, 470. Leave R3 empty for two resistors.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div>
          <label className={labelClass}>R1</label>
          <input
            type="text"
            value={r1}
            onChange={(e) => setR1(e.target.value)}
            placeholder="e.g. 1k"
            className={inputClass}
          />
        </div>
        <div>
          <label className={labelClass}>R2</label>
          <input
            type="text"
            value={r2}
            onChange={(e) => setR2(e.target.value)}
            placeholder="e.g. 1k"
            className={inputClass}
          />
        </div>
        <div>
          <label className={labelClass}>R3 (optional)</label>
          <input
            type="text"
            value={r3}
            onChange={(e) => setR3(e.target.value)}
            placeholder="optional"
            className={inputClass}
          />
        </div>
      </div>
      {total != null && (
        <div className={resultClass}>
          <span className="text-gray-600 text-sm">Parallel R: </span>
          <span className="font-semibold text-gray-900">{total.toFixed(4)} Ω</span>
        </div>
      )}
    </div>
  );
};

export default ParallelResistance;
